import PropTypes from 'prop-types'

import CategoryHeaderIcon from '../../shared/CategoryHeaderIcon'

import './categoryHeader.scss'

const CategoryHeader = ({categoryDisplayName, categoryName}) => (
  <header className='category-header flex-container'>
    <CategoryHeaderIcon categoryName={categoryName} />
    <h5>{categoryDisplayName}</h5>
  </header>
)

CategoryHeader.propTypes = {
  categoryDisplayName: PropTypes.string,
  categoryName: PropTypes.string,
  isHousehold: PropTypes.bool
}

export default CategoryHeader
